import { createSlice } from "@reduxjs/toolkit";
import { THEMES } from "../../utils/constants.js";

const initialState = {
  mode: localStorage.getItem("theme") === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT, // default to light mode
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === THEMES.LIGHT ? THEMES.DARK : THEMES.LIGHT;
    },
    setTheme: (state, action) => {
      state.mode = action.payload;
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
